<!-- <mat-drawer-container class="example-container">
  <mat-drawer #sideNav mode="side"  position="end">
    Drawer content
  </mat-drawer>
</mat-drawer-container> -->

<div class="container"> 
  
    <mat-toolbar  class="sticky">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center"  >
          <div fxLayout="row">
            <button mat-button (click)="onNewJob()">
              <mat-icon>add_circle</mat-icon>
              <span class="logo"> New Job</span>
            </button>
            <button mat-button (click)="onJobStatus()" >
               <mat-icon>home</mat-icon>
               <span class="logo"> Home</span>
            </button>
            <!-- <button  mat-button [mdePopoverTriggerFor]="Popover"
            mdePopoverTriggerOn="click" >
              <mat-icon >view_headline</mat-icon>
              <span class="logo"> More</span>
            </button> -->
            <button  mat-button>
              <mat-icon >view_headline</mat-icon>
              <span class="logo"> More</span>
            </button>
            
          </div>
      </mat-toolbar-row>
  </mat-toolbar>
 </div>


 <!-- <mde-popover #Popover="mdePopover"  > 
  <mat-card >    
    <mat-card-content>      
      <button mat-button (click)="Logout()" >
        <mat-icon>person_pin</mat-icon>
        <span class="logo"> LogOut</span>
     </button>
    </mat-card-content>
  </mat-card>
</mde-popover> -->
 







 <!-- <div class="example-container" [class.example-is-mobile]="mobileQuery.matches" *ngIf="shouldRun">
  <mat-toolbar class="example-toolbar">
    <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
  
  </mat-toolbar> -->